module.exports = __webpack_public_path__ + "img/pk.eb6a4720.svg";